import {
  TypedUseSelectorHook,
  useDispatch as useReduxDispatch,
  useSelector as useReduxSelector,
} from "react-redux";
import type { RootState, AppDispatch } from "./store";
import { setAccessToken, setCustomerId, setRole } from "./slices/authSlice";

export const useDispatch = () => useReduxDispatch<AppDispatch>();
export const useSelector: TypedUseSelectorHook<RootState> = useReduxSelector;

interface AuthData {
  accessToken?: string;
  role?: "admin" | "customer";
  userId?: number;
}

export const useAuthDataSetter = () => {
  const dispatch = useDispatch();

  return (data: AuthData) => {
    if (data.accessToken) {
      dispatch(setAccessToken(data.accessToken));
    }
    if (data.role) {
      dispatch(setRole(data.role));
    }
    if (data.userId) {
      dispatch(setCustomerId(data.userId));
    }
  };
};
